// extracted by mini-css-extract-plugin
export default {"button":"_-_-record-it-components-src-modal-BaseDialogButton-__button"};